import React, { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

/**
 * Drop-in replacement for <input type="password" />.
 * All props are passed through to the <input>; className/style stay on the input.
 * Optional: wrapperStyle to tweak the wrapper (defaults to block / relative / 100% width).
 */
export default function PasswordInput({ style, wrapperStyle, disabled, ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <span style={{ display: 'block', position: 'relative', width: '100%', ...wrapperStyle }}>
      <input
        {...rest}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
        style={{ width: '100%', boxSizing: 'border-box', ...style, paddingRight: 40 }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 26, height: 26, padding: 0, margin: 0,
          background: 'transparent', border: 'none', borderRadius: 6,
          color: '#8a91a8', cursor: 'pointer', lineHeight: 0,
        }}
      >
        {visible
          ? <EyeSlashIcon style={{ width: 18, height: 18 }} />
          : <EyeIcon style={{ width: 18, height: 18 }} />}
      </button>
    </span>
  );
}
